export default "__VITE_ASSET__DMW5gSHM__"